<template>
    <div class="container">
        <div
            :class="[
                'head-nav',
                navbarBack ? 'nav-style1' : 'nav-style2',
                screenHeight >= 812 ? 'maxNav' : 'minNav',
            ]"
        >
            <div v-if="navbarBack" class="nav-back" @click="goback"></div>
            <div class="nav-right-butn" @click="navRightItmeClick">
                {{ navRightData.linkName }}
            </div>
        </div>
        <div :class="['nav-title', screenHeight >= 812 ? 'maxScreenTit' : 'minScreenTit']"></div>
        <div
            class="energy-top"
            :style="{ backgroundImage: `url(${upFloatWindowData.imageUrl})` }"
            v-if="
                upFloatWindowData &&
                upFloatWindowData.imageUrl &&
                upFloatWindowData.floatingWindowType !== 'LOTTIE'
            "
            @click="upFloatWindowClick"
        ></div>
        <lottieResourceBit
            v-else-if="upFloatWindowData && upFloatWindowData.floatingWindowType === 'LOTTIE'"
            :position="{ right: '0px', top: '60px' }"
            @click="upFloatWindowClick"
            :lottieJson="upFloatWindowData && upFloatWindowData.lottieJson"
        />

        <!-- 活力值模块 -->
        <template v-if="getScoreInfo">
            <div class="score-area">
                <div class="score-top">
                    <div class="grade-ic" v-if="scoreProgressInfo.currentLevelIndex">
                        <span class="curr-level">{{ scoreProgressInfo.currentLevelIndex }}</span>
                    </div>
                    <div class="score-title" @click="scoreRecordClick(scoreExpireTips)">活力值</div>
                    <div class="arrow-right"></div>
                </div>
                <div @click="scoreRecordClick(scoreExpireTips)">
                    <ICountUp
                        class="score-value"
                        :delay="delay"
                        :endVal="totalScore"
                        :options="options"
                    />
                </div>
                <div class="score-botm">
                    <div class="score-badge">
                        {{
                            scoreExpireTips ? `${scoreExpireTips.expiringScore}活力值下月过期` : ''
                        }}
                    </div>
                    <div class="curr-grate">
                        {{ scoreProgressInfo ? scoreProgressInfo.currentLevelIndex : 1 }}
                    </div>
                </div>
            </div>
        </template>
        <!-- 气泡模块 -->
        <div
            class="qipao qipao2"
            :class="{ 'collect-in': ppCollectIndex_1 }"
            v-if="scoreList && scoreList.length > 1 && scoreList[1].taskId > 0"
        >
            <div class="qipao-content">
                <div
                    :class="[
                        'qipao-bg',
                        scoreList[1].bubbleType === 1
                            ? 'qipao-bg-gray'
                            : scoreList[1].bubbleType === 2
                            ? 'qipao-bg-zw'
                            : '',
                    ]"
                    @click="qipaoClick(1)"
                >
                    <template v-if="scoreList[1].bubbleType === 2">
                        <div>
                            <div class="qipao-scoredes">
                                明日
                                <div>可领</div>
                            </div>
                        </div>
                    </template>
                    <template v-else>
                        <div>
                            {{ scoreList[1].afterRewardScore }}
                        </div>
                    </template>
                </div>
                <CountDown
                    class="qipao-title"
                    v-show="showqipaoCountdown(1)"
                    id="countdownValue1"
                    format="DD天HH时mm分"
                    :time="scoreList[1].countDown"
                />
                <div class="qipao-title" v-show="showqipaoTitle(1)">
                    <div
                        class="hand-qp"
                        v-if="countDownIsShow && scoreList[1].bubbleType === 0"
                    ></div>
                    {{
                        countDownIsShow && scoreList[1].bubbleType === 0
                            ? '点击领取'
                            : qipaoTitleRang(scoreList[1].title)
                    }}
                </div>
                <div
                    class="marketingtips right-tip"
                    :style="{
                        width: isBasicScore(scoreList[1])
                            ? '190px'
                            : marketTipWidth(
                                  scoreList[1].desc,
                                  isShowNewUserQipaoTips(scoreList[1])
                              ) + 'px',
                        'margin-left': marketMarginRight(scoreList[1]) + 'px',
                    }"
                    v-if="
                        (isShowNewUserQipaoTips(scoreList[1]) || scoreList[1].bubbleType === 1) &&
                        showMarketTips === 1
                    "
                    @click="marketTipClick(scoreList[1], 1)"
                >
                    {{
                        isBasicScore(scoreList[1])
                            ? '领取激活奖励，可获额外活力值'
                            : isShowNewUserQipaoTips(scoreList[1])
                            ? '恭喜您完成新人引导,'
                            : markerTipDesc(scoreList[1].desc)
                    }}
                    <span v-if="!isBasicScore(scoreList[1])" class="yx-tip-butn"
                        >{{
                            isShowNewUserQipaoTips(scoreList[1])
                                ? '请领取新人福利'
                                : scoreList[1].buttonText
                        }}
                        <div v-show="!isShowNewUserQipaoTips(scoreList[1])" class="yx-arraw"></div>
                    </span>
                </div>
            </div>
        </div>
        <div
            class="qipao qipao1"
            :class="{ 'collect-in': ppCollectIndex_0 }"
            v-if="scoreList && scoreList.length > 0 && scoreList[0].taskId > 0"
        >
            <div class="qipao-content">
                <div
                    :class="[
                        'qipao-bg',
                        scoreList[0].bubbleType === 1
                            ? 'qipao-bg-gray'
                            : scoreList[0].bubbleType === 2
                            ? 'qipao-bg-zw'
                            : '',
                    ]"
                    @click="qipaoClick(0)"
                >
                    <template v-if="scoreList[0].bubbleType === 2">
                        <div>
                            <div class="qipao-scoredes">
                                明日
                                <div>可领</div>
                            </div>
                        </div>
                    </template>
                    <template v-else>
                        <div>
                            {{ scoreList[0].afterRewardScore }}
                        </div>
                    </template>
                </div>
                <CountDown
                    class="qipao-title"
                    v-show="showqipaoCountdown(0)"
                    id="countdownValue0"
                    format="DD天HH时mm分"
                    :time="scoreList[0].countDown"
                />
                <div class="qipao-title" v-show="showqipaoTitle(0)">
                    <div
                        class="hand-qp"
                        v-if="countDownIsShow && scoreList[0].bubbleType === 0"
                    ></div>
                    {{
                        countDownIsShow && scoreList[0].bubbleType === 0
                            ? '点击领取'
                            : qipaoTitleRang(scoreList[0].title)
                    }}
                </div>
                <template
                    v-if="
                        (isShowNewUserQipaoTips(scoreList[0]) || scoreList[0].bubbleType === 1) &&
                        showMarketTips === 0
                    "
                >
                    <div
                        class="marketingtips left-tip"
                        :style="{
                            width: isBasicScore(scoreList[0])
                                ? '190px'
                                : marketTipWidth(scoreList[0].desc) + 'px',
                        }"
                        @click="marketTipClick(scoreList[0], 0)"
                    >
                        {{
                            isBasicScore(scoreList[0])
                                ? '领取激活奖励，可获额外活力值'
                                : markerTipDesc(scoreList[0].desc)
                        }}
                        <span v-if="!isBasicScore(scoreList[0])" class="yx-tip-butn"
                            >{{ scoreList[0].buttonText }}
                            <div class="yx-arraw"></div>
                        </span></div
                ></template>
            </div>
        </div>
        <div
            class="qipao qipao3"
            :class="{ 'collect-in': ppCollectIndex_2 }"
            v-if="scoreList && scoreList.length > 2 && scoreList[2].taskId > 0"
        >
            <div class="qipao-content">
                <div
                    :class="['qipao-bg', scoreList[2].bubbleType === 1 ? 'qipao-bg-gray' : '']"
                    @click="qipaoClick(2)"
                >
                    {{ scoreList[2].afterRewardScore }}
                </div>
                <CountDown
                    class="qipao-title"
                    v-show="showqipaoCountdown(2)"
                    id="countdownValue2"
                    format="DD天HH时mm分"
                    :time="scoreList[2].countDown"
                />
                <div class="qipao-title" v-show="showqipaoTitle(2)">
                    <div
                        class="hand-qp"
                        v-if="countDownIsShow && scoreList[2].bubbleType === 0"
                    ></div>
                    {{
                        countDownIsShow && scoreList[2].bubbleType === 0
                            ? '点击领取'
                            : qipaoTitleRang(scoreList[2].title)
                    }}
                </div>
                <div
                    class="marketingtips right-tip"
                    :style="{
                        width: marketTipWidth(scoreList[2].desc) + 'px',
                        'margin-left': marketMarginRight(scoreList[2]) + 'px',
                    }"
                    v-if="scoreList[2].bubbleType === 1 && showMarketTips === 2"
                    @click="marketTipClick(scoreList[2], 2)"
                >
                    {{ markerTipDesc(scoreList[2].desc) }}
                    <span class="yx-tip-butn"
                        >{{ scoreList[2].buttonText }}
                        <div class="yx-arraw"></div>
                    </span>
                </div>
            </div>
        </div>
        <div
            class="qipao qipao5"
            :class="{ 'collect-in': ppCollectIndex_4 }"
            v-if="scoreList && scoreList.length > 4 && scoreList[4].taskId > 0"
        >
            <div class="qipao-content">
                <div
                    :class="['qipao-bg', scoreList[4].bubbleType === 1 ? 'qipao-bg-gray' : '']"
                    @click="qipaoClick(4)"
                >
                    {{ scoreList[4].afterRewardScore }}
                </div>
                <CountDown
                    class="qipao-title"
                    v-show="showqipaoCountdown(4)"
                    id="countdownValue4"
                    format="DD天HH时mm分"
                    :time="scoreList[4].countDown"
                />
                <div class="qipao-title" v-show="showqipaoTitle(4)">
                    <div
                        class="hand-qp"
                        v-if="countDownIsShow && scoreList[4].bubbleType === 0"
                    ></div>
                    {{
                        countDownIsShow && scoreList[4].bubbleType === 0
                            ? '点击领取'
                            : qipaoTitleRang(scoreList[4].title)
                    }}
                </div>
                <div
                    class="marketingtips right-tip"
                    :style="{
                        width: marketTipWidth(scoreList[4].desc) + 'px',
                        'margin-left': marketMarginRight(scoreList[4]) + 'px',
                    }"
                    v-if="scoreList[4].bubbleType === 1 && showMarketTips === 4"
                    @click="marketTipClick(scoreList[4], 4)"
                >
                    {{ markerTipDesc(scoreList[4].desc) }}
                    <span class="yx-tip-butn"
                        >{{ scoreList[4].buttonText }}
                        <div class="yx-arraw"></div>
                    </span>
                </div>
            </div>
        </div>
        <div
            class="qipao qipao4"
            :class="{ 'collect-in': ppCollectIndex_3 }"
            v-if="scoreList && scoreList.length > 3 && scoreList[3].taskId > 0"
        >
            <div class="qipao-content">
                <div
                    :class="['qipao-bg', scoreList[3].bubbleType === 1 ? 'qipao-bg-gray' : '']"
                    @click="qipaoClick(3)"
                >
                    {{ scoreList[3].afterRewardScore }}
                </div>
                <CountDown
                    class="qipao-title"
                    v-show="showqipaoCountdown(3)"
                    id="countdownValue3"
                    format="DD天HH时mm分"
                    :time="scoreList[3].countDown"
                />
                <div class="qipao-title" v-show="showqipaoTitle(3)">
                    <div
                        class="hand-qp"
                        v-if="countDownIsShow && scoreList[3].bubbleType === 0"
                    ></div>
                    {{
                        countDownIsShow && scoreList[3].bubbleType === 0
                            ? '点击领取'
                            : qipaoTitleRang(scoreList[3].title)
                    }}
                </div>
                <div
                    class="marketingtips right-tip"
                    :style="{
                        width: marketTipWidth(scoreList[3].desc) + 'px',
                        'margin-left': marketMarginRight(scoreList[3]) + 'px',
                    }"
                    v-if="scoreList[3].bubbleType === 1 && showMarketTips === 3"
                    @click="marketTipClick(scoreList[3], 3)"
                >
                    {{ markerTipDesc(scoreList[3].desc) }}
                    <span class="yx-tip-butn"
                        >{{ scoreList[3].buttonText }}
                        <div class="yx-arraw"></div>
                    </span>
                </div>
            </div>
        </div>

        <!-- 进度条 -->
        <sProgress :progressData="scoreProgressInfo" @OnProgressClick="progressClick"></sProgress>

        <!-- 做任务领活力值 -->
        <taskScoreValue
            v-if="taskListData && taskListData.length"
            :taskList="taskListData"
            @OnTaskMoreClick="taskMoreClick"
            @OnTaskItemClick="taskItemClick"
        />
    </div>
</template>
<script>
import ICountUp from 'vue-countup-v2';
import homemixin from '@common/js/mixin';
import mixin4Comp from '@common/js/mixin4Comp';
import { CountDown } from 'vant';
import sProgress from '../scoreProgress/newprogress.vue';
import appBridge from '@/common/util/appBridge';
import taskScoreValue from './taskScoreValue';
import lottieResourceBit from '../LottieResourceBit';
export default {
    name: 'homeCard',
    components: {
        ICountUp,
        CountDown,
        sProgress,
        taskScoreValue,
        lottieResourceBit
    },
    mixins: [homemixin, mixin4Comp],
    props: [
        'guideNotice',
        'navbarBack',
        'upFloatWindowData',
        'showTaskGuide',
        'navRightData',
        'taskListData',
        'switch3dCat'
    ],
    data() {
        return {
            // 时间戳
            timestamp: 0,
            marketingBubbleNode: 0,
            scoreList: [],
            getScoreInfo: false,
            delay: 0,
            totalScore: 0, // 当前活力值
            allScore: 0, // 总活力值（包含待领取）
            nextLockScore: 0, // 下一解锁活力值
            upgradeProgress: 0, // 升级百分比
            scoreProgressInfo: {}, // 进度信息
            scoreExpireTips: null, // 过期活力值信息
            typeArr: [],
            options: {
                useEasing: true,
                useGrouping: true,
                separator: '',
                decimal: '.',
                prefix: '',
                suffix: ''
            },
            ppCollectIndex_0: false,
            ppCollectIndex_1: false,
            ppCollectIndex_2: false,
            ppCollectIndex_3: false,
            ppCollectIndex_4: false,
            showMarketTips: -1,
            countTimer: '',
            countDownIsShow: false,
            marketTipTimer: '', // 营销提示框倒计时8秒隐藏
            tipTimes: 0,
            screenHeight: screen.height,
            switch3d: false,
            tipPosition: { x: 0, y: 0 },
            top: '0',
            selectedCoinIndex: 0,
            title: false,
            bgSwitch: null,
            lottleResource: true
        };
    },

    computed: {
        tipShow() {
            return (
                this.scoreList.length &&
                this.scoreList[this.selectedCoinIndex].bubbleType === 1 &&
                this.showMarketTips === this.selectedCoinIndex
            );
        },
        tipDesc() {
            return this.markerTipDesc(this.scoreList[this.selectedCoinIndex].desc);
        },
        buttonText() {
            return this.scoreList[this.selectedCoinIndex].buttonText;
        }
    },
    watch: {
        guideNotice(n, o) {
            this.getBubbleScoreList();
            this.userGuideNotice();
            this.getScoreProgress();
        },
        taskListData: {
            deep: true,
            immediate: true,
            handler: function(newV) {
                if (newV && newV.length) {
                    newV.forEach(item => {
                        let timeValue =
                            item.taskType === 'marketing'
                                ? document.getElementById('yx-countdownValue') &&
                                  document.getElementById('yx-countdownValue').innerText
                                : item.taskType === 'signIn'
                                    ? `${item.countDown}天`
                                    : '';
                        this.POINT('h5_element_imp', {
                            page: 'super-成长权益页',
                            tgt_event_id: 'h5_ACT_bubbletaskcard',
                            tgt_name: 'h5-ACT-成长权益-气泡任务卡片',
                            param: this.totalScore,
                            param1: this.allScore,
                            param2: this.scoreProgressInfo.currentLevelIndex,
                            param3: item.title,
                            param4: item.afterRewardScore,
                            param5: item.desc,
                            param6: item.score,
                            param7: item.afterRewardScore - item.score,
                            param8: timeValue,
                            param9: item.taskId
                        });
                    });
                }
            }
        }
    },
    created() {
        this.receivedQiPao = this.debounce2(
            value => {
                this.qipaoClickRe(value);
            },
            200,
            true
        );
        console.log('screenHeight11', this.screenHeight);
    },
    mounted() {
        setTimeout(() => {
            appBridge.pullToRefresh({ refreshBackColor: '#CDC7BA' });
        }, 1500);
        this.countTimer = setInterval(() => {
            this.countDownIsShow = !this.countDownIsShow;
        }, 4000);
    },
    beforeDestroy() {
        clearInterval(this.countTimer);
        if (this.marketTipTimer) {
            clearInterval(this.marketTipTimer);
        }
    },
    methods: {
        goback() {
            this.$emit('OnGoBack');
        },
        guideQPClick() {
            this.scoreList.forEach((items, qpIndex) => {
                if (items.bubbleType === 0 && items.taskId === 104) {
                    this.qipaoClick(qpIndex);
                }
            });
        },
        // 领取基础分引导
        showBasicScoreGuide() {
            this.scoreList.forEach((items, qpIndex) => {
                if (items.bubbleType === 0 && items.taskId === 104) {
                    this.POINT('h5_element_imp', {
                        page: 'super-成长权益页',
                        tgt_event_id: 'h5_ACT_privilege_bubbleTS',
                        tgt_name: 'h5-ACT-成长权益-气泡提示',
                        param: `${this.totalScore}`,
                        param1: this.allScore,
                        param2: items.title,
                        param3: '领取激活奖励，可获额外活力值'
                    });
                    this.showMarketTips = qpIndex;
                    setTimeout(() => {
                        this.showMarketTips = -1;
                    }, 6000);
                }
            });
        },
        navRightItmeClick() {
            this.POINT('h5_clk', {
                page: 'super-成长权益页',
                tgt_name: 'h5-ACT-成长权益-首页右上角配置位',
                tgt_event_id: 'h5_ACT_bbsjtc_rule',
                param: this.navRightData ? this.navRightData.linkName : '',
                param1: this.navRightData ? this.navRightData.redirectUrl : ''
            });
            if (this.navRightData && this.navRightData.redirectUrl) {
                this.openLink(this.navRightData.redirectUrl);
            }
        },
        scoreRecordClick(value) {
            this.$emit('OnScoreRecord', value);
        },
        marketTipClick(scoreItem, index) {
            let timesV = scoreItem.countDown
                ? document.getElementById('countdownValue' + `${index}`) &&
                  document.getElementById('countdownValue' + `${index}`).innerText
                : '';
            this.POINT('h5_clk', {
                page: 'super-成长权益页',
                tgt_event_id: 'h5_ACT_privilege_yxqprwts',
                tgt_name: 'h5-ACT-成长权益-营销气泡任务提示',
                param: `${this.totalScore}`,
                param1: scoreItem.title,
                param2: scoreItem.desc,
                param3: scoreItem.buttonText,
                param4: scoreItem.afterRewardScore,
                param5: scoreItem.score,
                param6: scoreItem.afterRewardScore - scoreItem.score,
                param7: timesV ? timesV : '',
                param8: scoreItem.redirectUrl ? scoreItem.redirectUrl : '',
                param9: scoreItem.taskId,
                param10: this.switch3d ? '是' : '否'
            });
            this.$emit('OnMarketTipClick', scoreItem);
        },
        // 是否是展示气泡引导
        isShowNewUserQipaoTips(item) {
            if (item.taskId === 501 && item.bubbleType === 0 && item.exposureDaysTillToday <= 1) {
                return true;
            }
            if (item.taskId === 104 && item.bubbleType === 0) {
                return true;
            }
            return false;
        },
        // 基础分待领取
        isBasicScore(item) {
            if (item.taskId === 104 && item.bubbleType === 0) {
                return true;
            }
            return false;
        },
        isShowMarketTips(value) {
            this.showMarketTips = value;
            this.tipTimes = 0;
            if (this.marketTipTimer) {
                clearInterval(this.marketTipTimer);
            }
            if (value >= 0) {
                this.marketTipTimer = setInterval(() => {
                    this.tipTimes++;
                    if (this.tipTimes >= 8) {
                        this.showMarketTips = -1;
                        this.tipTimes = 0;
                        clearInterval(this.marketTipTimer);
                    }
                }, 1000);
            }
        },
        qipaoClick(value) {
            this.receivedQiPao(value);
        },
        async qipaoClickRe(value, resolve) {
            let scoreItem = this.scoreList[value];
            if (scoreItem.taskId < 0) {
                return;
            }
            if (scoreItem.taskId === 501) {
                let timesV = scoreItem.bubbleType === 2 ? '明日可领' : '';
                this.POINT('h5_clk', {
                    page: 'super-成长权益页',
                    tgt_name: 'h5-ACT-成长权益-新人福利气泡',
                    tgt_event_id: 'h5_ACT_privilege_xrflqp',
                    param: this.totalScore > 0 ? this.totalScore : 0,
                    param1: scoreItem.exposureDaysTillYesterday + 1,
                    param2: scoreItem.score,
                    param3: scoreItem.bubbleType === 2 ? '占位气泡' : '可领气泡',
                    param4: this.allScore,
                    param5: timesV,
                    param6: scoreItem.title,
                    param7: this.isShowNewUserQipaoTips(scoreItem)
                        ? '恭喜您完成新人引导，请领取新人福利'
                        : '',
                    param8: this.switch3d ? '是' : '否'
                });
            } else {
                var timesV = '';
                if (scoreItem.bubbleType === 2) {
                    timesV = '明日可领';
                } else if (scoreItem.bubbleType === 1) {
                    timesV = scoreItem.countDown
                        ? document.getElementById('countdownValue' + `${value}`) &&
                          document.getElementById('countdownValue' + `${value}`).innerText
                        : '';
                }
                this.POINT('h5_clk', {
                    page: 'super-成长权益页',
                    tgt_name: 'h5-ACT-成长权益-活力值气泡',
                    tgt_event_id: 'h5_ACT_privilege_bubble',
                    param: this.totalScore > 0 ? this.totalScore : 0,
                    param1: scoreItem.bubbleType,
                    param2: scoreItem.title,
                    param3: scoreItem.afterRewardScore,
                    param4: scoreItem.score,
                    param5: scoreItem.taskId,
                    param6: scoreItem.afterRewardScore - scoreItem.score,
                    param7: scoreItem.bubbleType === 1 ? timesV : '',
                    param8: this.allScore,
                    param9: scoreItem.bubbleType === 2 ? timesV : '',
                    param10: this.switch3d ? '是' : '否'
                });
            }
            if (scoreItem.bubbleType === 1) {
                // 营销气泡
                // let timeValue = scoreItem.countDown
                //     ? document.getElementById('countdownValue' + `${value}`).innerText && document.getElementById('countdownValue' + `${value}`).innerText
                //     : '';
                let timeValue = scoreItem.countDown
                    ? document.getElementById('countdownValue' + `${value}`) &&
                      document.getElementById('countdownValue' + `${value}`).innerText
                    : '';
                if (this.showMarketTips === value) {
                    this.$emit('OnMarketTipClick', scoreItem);
                }
                this.isShowMarketTips(value);
                this.POINT('h5_element_imp', {
                    page: 'super-成长权益页',
                    tgt_event_id: 'h5_ACT_privilege_yxqprwts',
                    tgt_name: 'h5-ACT-成长权益-营销气泡任务提示',
                    param: `${this.totalScore}`,
                    param1: scoreItem.title,
                    param2: scoreItem.desc,
                    param3: scoreItem.buttonText,
                    param4: scoreItem.afterRewardScore,
                    param5: scoreItem.score,
                    param6: scoreItem.afterRewardScore - scoreItem.score,
                    param7: timeValue ? timeValue : '',
                    param8: scoreItem.redirectUrl ? scoreItem.redirectUrl : '',
                    param9: scoreItem.taskId,
                    param10: this.switch3d ? '是' : '否'
                });
                return;
            } else {
                this.showMarketTips = -1;
            }
            if (scoreItem.bubbleType === 2) {
                // 占位气泡
                this.$toast({ message: '明日还可以再领哦', duration: 2000 });
                return;
            }
            if (scoreItem.receivedStatus === 1) {
                return;
            }
            scoreItem.receivedStatus = 1;
            const { Result, Content, ResultMessage } = await this.$http.receiveBubbleScore({
                id: this.scoreList[value].id,
                taskId: this.scoreList[value].taskId,
                timestamp: this.timestamp,
                marketingBubbleNode: this.marketingBubbleNode
            });
            // const { Result, Content, ResultMessage } = require('./receiveBubbleScore.json');
            if (Result === 200 && Content) {
                this.timestamp = Content.timestamp;
                this.marketingBubbleNode = Content.marketingBubbleNode;
                localStorage.setItem('KUserTotalScore', Content.totalScore);
                resolve && resolve(true);
                this.getScoreProgress();
                setTimeout(() => {
                    this.nextLockScore = Content.differenceOfNextLockScore;
                    this.upgradeProgress = Content.upgradeProgress;
                }, 2000);
                if (Content.nextBubbleScore) {
                    const item = Content.nextBubbleScore;
                    item.receivedStatus = 0;
                    Object.assign(this, { [`ppCollectIndex_${value}`]: true });
                    setTimeout(() => {
                        scoreItem.receivedStatus = 2;
                        this.totalScore = this.totalScore + this.scoreList[value].score;
                        Object.assign(this, { [`ppCollectIndex_${value}`]: false });
                        this.scoreList.splice(value, 1, item);
                        this.$emit(
                            'OnBubbleScoreList',
                            this.scoreList,
                            Content.isFirstTimeUpgrade || Content.upgrade
                        );
                        if (item.bubbleType === 2) {
                            this.showPopupTaskList();
                        }
                    }, 1000);
                    if (item.taskId === 501) {
                        // 有下发新人气泡通知才曝光
                        if (this.typeArr.indexOf('newUserBubbleNotice') > -1) {
                            this.newUserBubbleEmp();
                        }
                        setTimeout(() => {
                            let timesV = item.bubbleType === 2 ? '明日可领' : '';
                            this.POINT('h5_element_imp', {
                                page: 'super-成长权益页',
                                tgt_event_id: 'h5_ACT_privilege_xrflqp',
                                tgt_name: 'h5-ACT-成长权益-新人福利气泡',
                                param: `${this.totalScore}`,
                                param1: item.exposureDaysTillYesterday + 1,
                                param2: item.score,
                                param3: item.bubbleType === 2 ? '占位气泡' : '可领气泡',
                                param4: this.allScore,
                                param5: timesV,
                                param6: item.title,
                                param7: this.isShowNewUserQipaoTips(item)
                                    ? '恭喜您完成新人引导，请领取新人福利'
                                    : '',
                                param8: this.switch3d ? '是' : '否'
                            });
                        }, 1500);
                    } else {
                        var timesV = '';
                        if (item.bubbleType === 2) {
                            timesV = '明日可领';
                        } else if (item.bubbleType === 1) {
                            timesV = item.countDown
                                ? document.getElementById('countdownValue' + `${value}`) &&
                                  document.getElementById('countdownValue' + `${value}`).innerText
                                : '';
                        }
                        this.POINT('h5_element_imp', {
                            page: 'super-成长权益页',
                            tgt_event_id: 'h5_ACT_privilege_bubble',
                            tgt_name: 'h5-ACT-成长权益-活力值气泡',
                            param: `${this.totalScore}`,
                            param1: item.bubbleType,
                            param2: item.title,
                            param3: item.afterRewardScore,
                            param4: item.score,
                            param5: item.taskId,
                            param6: item.afterRewardScore - item.score,
                            param7: item.bubbleType === 1 ? timesV : '',
                            param8: this.allScore,
                            param9: item.bubbleType === 2 ? timesV : '',
                            param10: this.switch3d ? '是' : '否'
                        });
                    }
                } else {
                    // 无领取气泡，生成占位数据
                    Object.assign(this, { [`ppCollectIndex_${value}`]: true });
                    setTimeout(() => {
                        scoreItem.receivedStatus = 2;
                        this.totalScore = this.totalScore + this.scoreList[value].score;
                        const item = { taskId: -99 };
                        this.scoreList.splice(value, 1, item);
                        Object.assign(this, { [`ppCollectIndex_${value}`]: false });
                        this.$emit(
                            'OnBubbleScoreList',
                            this.scoreList,
                            Content.isFirstTimeUpgrade || Content.upgrade
                        );
                        this.showPopupTaskList();
                    }, 1000);
                }
                this.$emit(
                    'OnQiPaoSucc',
                    Content.totalScore,
                    Content.differenceOfNextLockScore,
                    scoreItem
                );
                if (Content.upgrade) {
                    // 是否弹升降弹窗
                    setTimeout(() => {
                        if (Content.isFirstTimeUpgrade) {
                            // 首次升级弹窗
                            this.$emit('OnShowFirstUpgardePopup');
                        } else {
                            this.$emit('onShowUpgrade', Content.upgradeInfo, Content.totalScore);
                        }
                    }, 2000);
                }
                if (scoreItem.taskId === 104) {
                    // 领取基础分 出发签到任务信息
                    // this.getSignInTaskInfo();
                }
            } else if (Result === 40702) {
                // 不可领取
                this.$toast({ message: '活力值已失效', duration: 2000 });
                this.getBubbleScoreList();
                this.POINT('h5_auth', {
                    auth_tgt: 'super_privilege_errorMsg',
                    auth_tgt_name: 'super-成长权益-报错集合',
                    page: 'super-成长权益页',
                    ret_code: Result,
                    param: ResultMessage,
                    param1: '/growth/home/receiveBubbleScore',
                    param2: this.$route.query.source,
                    param3: this.switch3d ? '是' : '否'
                });
                return;
            } else if (Result === 40719) {
                this.getBubbleScoreList();
                this.$emit('OnShowOverdueDialog');
                return;
            } else if (Result === 40801) {
                this.$toast({ message: ResultMessage, duration: 2000 });
            } else {
                this.getBubbleScoreList();
                this.$toast({ message: '系统异常', duration: 2000 });
                this.POINT('h5_auth', {
                    auth_tgt: 'super_privilege_errorMsg',
                    auth_tgt_name: 'super-成长权益-报错集合',
                    page: 'super-成长权益页',
                    ret_code: Result,
                    param: ResultMessage,
                    param1: '/growth/home/receiveBubbleScore',
                    param2: this.$route.query.source,
                    param3: this.switch3d ? '是' : '否'
                });
                return;
            }
        },
        async guideClose(value) {
            let notice = value === 1 ? 'receiveScoreNotice' : 'increaseScoreNotice';
            this.guideNotice.forEach(item => {
                if (item.noticeType === notice) {
                    this.POINT('h5_clk', {
                        page: 'super-成长权益页',
                        tgt_event_id: 'h5_ACT_privilege_guide',
                        tgt_name: 'h5-ACT-成长权益-引导提示',
                        param: this.totalScore,
                        param1: value === 1 ? '1' : '2',
                        param2: item.readTimes + 1
                    });
                }
            });
            const { Result } = await this.$http.setNoticeStatus({
                noticeType: notice,
                isRead: true
            });
            if (Result === 200) {
            }
        },
        showTaskList(callMethod) {
            this.$emit('OnshowTaskList', 'homecard', callMethod);
        },
        async newUserBubbleEmp() {
            const { Result } = await this.$http.setNoticeStatus({
                noticeType: 'newUserBubbleNotice',
                isRead: true
            });
            if (Result === 200) {
                this.typeArr = this.typeArr.filter(function(item) {
                    return item !== 'newUserBubbleNotice';
                });
            }
        },
        async getBubbleScoreList() {
            const { Result, Content, ResultMessage } = await this.$http.getBubbleScoreList({});
            if (Result === 200 && Content) {
                this.totalScore = Content.scoreInfo.totalScore;
                this.allScore = Content.scoreInfo.allScore;
                this.scoreList = Content.bubbleScoreList;
                this.scoreExpireTips = Content.scoreExpireTips;
                const taskIdArr = [];
                this.scoreList.forEach((item, qpIndex) => {
                    // receivedStatus: 0 未领取； 1:领取中； 2:领取成功
                    item.receivedStatus = 0;
                    taskIdArr.push(item.taskId);
                    if (item.taskId === 501) {
                        // 新人气泡曝光
                        if (item.bubbleType === 0) {
                            this.isShowMarketTips(qpIndex);
                        }
                        setTimeout(() => {
                            let timesV = item.bubbleType === 2 ? '明日可领' : '';
                            this.POINT('h5_element_imp', {
                                page: 'super-成长权益页',
                                tgt_event_id: 'h5_ACT_privilege_xrflqp',
                                tgt_name: 'h5-ACT-成长权益-新人福利气泡',
                                param: this.totalScore,
                                param1: item.exposureDaysTillYesterday + 1,
                                param2: item.score,
                                param3: item.bubbleType === 2 ? '占位气泡' : '可领气泡',
                                param4: this.allScore,
                                param5: timesV,
                                param6: item.title,
                                param7: this.isShowNewUserQipaoTips(item)
                                    ? '恭喜您完成新人引导，请领取新人福利'
                                    : '',
                                param8: this.switch3d ? '是' : '否'
                            });
                        }, 1500);
                    } else {
                        if (item.countDown && item.countDown > 0) {
                            setTimeout(() => {
                                // 延迟1秒获取渲染气泡元素
                                let timesV = '';
                                if (item.bubbleType === 2) {
                                    timesV = '明日可领';
                                } else if (item.bubbleType === 1) {
                                    // timesV = item.countDown
                                    //     ? document.getElementById('countdownValue' + `${qpIndex}`)
                                    //         .innerText
                                    //     : '';
                                }
                                this.POINT('h5_element_imp', {
                                    page: 'super-成长权益页',
                                    tgt_event_id: 'h5_ACT_privilege_bubble',
                                    tgt_name: 'h5-ACT-成长权益-活力值气泡',
                                    param: this.totalScore,
                                    param1: item.bubbleType,
                                    param2: item.title,
                                    param3: item.afterRewardScore,
                                    param4: item.score,
                                    param5: item.taskId,
                                    param6: item.afterRewardScore - item.score,
                                    param7: item.bubbleType === 1 ? timesV : '',
                                    param8: this.allScore,
                                    param9: item.bubbleType === 2 ? timesV : '',
                                    param10: this.switch3d ? '是' : '否'
                                });
                            }, 1500);
                        } else {
                            this.POINT('h5_element_imp', {
                                page: 'super-成长权益页',
                                tgt_event_id: 'h5_ACT_privilege_bubble',
                                tgt_name: 'h5-ACT-成长权益-活力值气泡',
                                param: this.totalScore,
                                param1: item.bubbleType,
                                param2: item.title,
                                param3: item.afterRewardScore,
                                param4: item.score,
                                param5: item.taskId,
                                param6: item.afterRewardScore - item.score,
                                param8: this.allScore,
                                param10: this.switch3d ? '是' : '否'
                            });
                        }
                    }
                });
                this.getScoreInfo = true;
                this.timestamp = Content.timestamp;
                this.marketingBubbleNode = Content.marketingBubbleNode;
                this.nextLockScore = Content.scoreInfo.differenceOfNextLockScore;
                this.upgradeProgress = Content.scoreInfo.upgradeProgress;
                this.$emit('OnBubbleScoreList', this.scoreList);
                // 有下发新人气泡通知才曝光
                if (
                    taskIdArr.indexOf(501) > -1 &&
                    this.typeArr.indexOf('newUserBubbleNotice') > -1
                ) {
                    this.newUserBubbleEmp();
                }
                this.POINT('h5_element_imp', {
                    page: 'super-成长权益页',
                    tgt_name: 'h5-ACT-成长权益-任务按钮',
                    tgt_event_id: 'h5_ACT_privilege_taskButton',
                    param: this.totalScore > 0 ? this.totalScore : 0,
                    param1: this.allScore,
                    param2: this.typeArr.indexOf('taskListButtonGuide') > -1 ? '限时福利' : '',
                    param3: this.switch3d ? '是' : '否'
                });
                if (this.scoreExpireTips && this.scoreExpireTips.expiringScore) {
                    this.POINT('h5_element_imp', {
                        page: 'super-成长权益页',
                        tgt_name: 'h5-ACT-成长权益-过期活力值提示',
                        tgt_event_id: 'h5_ACT_privilege_gqhlzts',
                        param: this.totalScore > 0 ? this.totalScore : 0,
                        param1: this.allScore,
                        param2: `${this.scoreExpireTips.expiringScore}活力值下月过期`,
                        param3: this.switch3d ? '是' : '否'
                    });
                }
            } else {
                this.POINT('h5_auth', {
                    auth_tgt: 'super_privilege_errorMsg',
                    auth_tgt_name: 'super-成长权益-报错集合',
                    page: 'super-成长权益页',
                    ret_code: Result,
                    param: ResultMessage,
                    param1: '/growth/home/getBubbleScoreList',
                    param2: this.$route.query.source,
                    param3: this.switch3d ? '是' : '否'
                });
            }

            return {};
        },
        async getScoreProgress() {
            const { Result, Content } = await this.$http.getScoreProgressV2({});
            if (Result === 200) {
                this.scoreProgressInfo = Content;
                setTimeout(() => {
                    this.POINT('h5_element_imp', {
                        page: 'super-成长权益页',
                        tgt_event_id: 'h5_ACT_privilege_hlzjdt',
                        tgt_name: 'h5-ACT-成长权益-活力值进度条',
                        param: this.totalScore,
                        param1: this.allScore,
                        param2: this.switch3d ? '是' : '否'
                    });
                }, 2000);
            }
        },
        userGuideNotice() {
            this.typeArr = [];
            if (this.guideNotice) {
                this.guideNotice.forEach(item => {
                    this.typeArr.push(item.noticeType);
                });
            }
        },
        markerTipDesc(value) {
            if (!value) {
                return '';
            }
            if (value.length <= 12) {
                return value;
            } else {
                return value.substr(0, 12) + '...';
            }
        },
        marketTipWidth(value, newUserQP) {
            if (newUserQP) {
                return 228;
            }
            if (value.length > 12) {
                return 234;
            } else {
                return value.length * 14 + 56;
            }
        },
        marketMarginRight(value) {
            if (this.isShowNewUserQipaoTips(value)) {
                return -158;
            }
            return -value.desc.length * 11 - 12;
        },
        qipaoTitleRang(value) {
            if (value.length > 15) {
                return value.substr(0, 15) + '...';
            } else {
                return value;
            }
        },
        showqipaoTitle(index) {
            return this.scoreList[index].bubbleType !== 1 ||
                !this.countDownIsShow ||
                !this.scoreList[index].countDown ||
                this.scoreList[index].countDown === 0
                ? true
                : false;
        },
        showqipaoCountdown(index) {
            return this.scoreList[index].countDown &&
                this.scoreList[index].countDown > 0 &&
                this.scoreList[index].bubbleType === 1 &&
                this.countDownIsShow
                ? true
                : false;
        },
        countDFinish() {
            this.scoreList = [];
            this.getBubbleScoreList();
        },
        marketTitleValue(title) {
            if (title && title.length > 9) {
                return title.substr(0, 8) + '...';
            } else {
                return title;
            }
        },
        progressClick() {
            this.POINT('h5_clk', {
                page: 'super-成长权益页',
                tgt_event_id: 'h5_ACT_privilege_hlzjdt',
                tgt_name: 'h5-ACT-成长权益-活力值进度条',
                param: this.totalScore,
                param1: this.allScore,
                param2: this.switch3d ? '是' : '否'
            });
            setTimeout(() => {
                this.openLink(`${window.location.protocol}//invgrowth.ppdai.com/#/allBenefit`);
            }, 200);
        },
        showPopupTaskList() {
            const bubbleTypeArr = [];
            this.scoreList.forEach(item => {
                bubbleTypeArr.push(item.bubbleType);
            });
            if (!bubbleTypeArr.includes(0) && !bubbleTypeArr.includes(1)) {
                // 无可领气泡和营销气泡
                // this.$toast({ message: '做任务领活力值哦!', duration: 2000 });
            }
        },
        upFloatWindowClick() {
            this.POINT('h5_clk', {
                page: 'super-成长权益页',
                tgt_name: 'h5-ACT-成长权益-气泡区右上资源位',
                tgt_event_id: 'h5_ACT_privilege_qpqyszyw',
                param: this.totalScore,
                param1: this.allScore,
                param2: this.upFloatWindowData.floatingWindowId,
                param3: this.upFloatWindowData.imageUrl,
                param4: this.upFloatWindowData.redirectUrl,
                param5: this.switch3d ? '是' : '否'
            });
            if (this.upFloatWindowData.redirectUrl) {
                this.openLink(this.upFloatWindowData.redirectUrl);
            }
        },
        taskMoreClick() {
            this.POINT('h5_clk', {
                page: 'super-成长权益页',
                tgt_event_id: 'h5_ACT_bubbletasklist_moretask',
                tgt_name: 'h5-ACT-成长权益-气泡任务栏-更多任务',
                param: this.totalScore,
                param1: this.allScore,
                param2: this.scoreProgressInfo.currentLevelIndex
            });
            this.showTaskList();
        },
        taskItemClick(item) {
            let timeValue =
                item.taskType === 'marketing'
                    ? document.getElementById('yx-countdownValue') &&
                      document.getElementById('yx-countdownValue').innerText
                    : item.taskType === 'signIn'
                        ? `${item.countDown}天`
                        : '';
            this.POINT('h5_clk', {
                page: 'super-成长权益页',
                tgt_event_id: 'h5_ACT_bubbletaskcard',
                tgt_name: 'h5-ACT-成长权益-气泡任务卡片',
                param: this.totalScore,
                param1: this.allScore,
                param2: this.scoreProgressInfo.currentLevelIndex,
                param3: item.title,
                param4: item.afterRewardScore ? item.afterRewardScore : '',
                param5: item.desc,
                param6: item.score,
                param7: item.afterRewardScore ? item.afterRewardScore - item.score : '',
                param8: timeValue,
                param9: item.taskId ? item.taskId : ''
            });
            // 各类型任务卡片点击交互
            if (item.taskType === 'marketing') {
                this.yxTaskClick(item);
            } else if (item.taskType === 'signIn') {
                // 拉起任务浮窗，并触发签到
                this.showTaskList('callSignIn');
            } else if (item.taskType === 'normal') {
                item.redirectUrl && this.openLink(item.redirectUrl);
            } else if (item.taskType === 'allmore') {
                this.showTaskList();
            }
        },
        yxTaskClick(item) {
            if (item.taskHandler === 'ReceiveScoreTaskHandler') {
                this.showBasicScoreGuide();
                return;
            }
            this.$emit('OnMarketTipClick', item);
        }
    }
};
</script>

<style lang="less" scoped>
@asserts: '../../../../assets/iconV2.5/';
@assertsV4: '../../../../assets/growth4.0/';
.container {
    background-image: url('@{assertsV4}growth-home-bg@2x.png');
    background-size: 100% 100%;
    width: 375px;
    height: 500px;
    .nav-title {
        position: relative;
        font-size: 18px;
        width: 81px;
        height: 20px;
        background-image: url('@{asserts}/home-title@2x.png');
        background-size: 100% 100%;
        top: 8px;
    }
    .maxScreenTit {
        margin: -35px 147px 0;
    }
    .minScreenTit {
        margin: -45px 147px 0;
    }
    .nav-style1 {
        justify-content: space-between;
    }
    .nav-style2 {
        justify-content: flex-end;
    }
    .maxNav {
        padding: 40px 18px 0;
    }
    .minNav {
        padding: 16px 18px 0;
    }
    .head-nav {
        display: flex;
        flex-direction: row;
        color: #fff;
        font-weight: bolder;
        height: 79px;
        align-items: center;
        .nav-back {
            width: 24px;
            height: 24px;
            background-size: 100% 100%;
            background-image: url('@{asserts}/goback-icon@2x.png');
        }
        .nav-right-butn {
            margin-top: 4px;
            font-size: 14px;
            z-index: 99;
        }
    }
    .energy-top {
        position: absolute;
        margin-top: 10px;
        right: 0px;
        width: 60px;
        height: 60px;
        background-size: 100% 100%;
    }
    .qipao1 {
        margin-top: 86px;
        margin-left: 138px;
        &.collect-in {
            animation: vertical-collect-in-1 1s 0.1s 1;
            animation-timing-function: ease;
            .qipao-content {
                animation: hor-collect-in-1 1s linear 0.1s 1;
            }
        }
    }
    .qipao2 {
        margin-top: 75px;
        margin-left: 217px;
        &.collect-in {
            animation: vertical-collect-in-2 1s 0.1s 1;
            animation-timing-function: ease;
            .qipao-content {
                animation: hor-collect-in-2 1s linear 0.1s 1;
            }
        }
    }
    .qipao3 {
        margin-top: 139px;
        margin-left: 187px;
        &.collect-in {
            animation: vertical-collect-in-3 1s 0.1s 1;
            animation-timing-function: ease;
            .qipao-content {
                animation: hor-collect-in-3 1s linear 0.1s 1;
            }
        }
    }
    .qipao4 {
        margin-top: 125px;
        margin-left: 261px;
        &.collect-in {
            animation: vertical-collect-in-4 1s 0.1s 1;
            animation-timing-function: ease;
            .qipao-content {
                animation: hor-collect-in-4 1s linear 0.1s 1;
            }
        }
    }
    .qipao5 {
        margin-top: 63px;
        margin-left: 280px;
        &.collect-in {
            animation: vertical-collect-in-5 1s 0.1s 1;
            animation-timing-function: ease;
            .qipao-content {
                animation: hor-collect-in-5 1s linear 0.1s 1;
            }
        }
    }
    .qipao {
        width: 86px;
        height: 60px;
        position: absolute;
        animation: qipaofloat 1.3s ease-in-out 2.7s infinite alternate;
        .qipao-content {
            .qipao-bg {
                margin-left: 18px;
                width: 34px;
                height: 34px;
                background-image: url('@{asserts}/qipao-high@2x.png');
                background-size: 100% 100%;
                color: #fff;
                font-size: 11px;
                font-weight: bolder;
                text-align: center;
                line-height: 34px;
                opacity: 1;
                .qipao-score {
                    color: #fff;
                    font-size: 10px;
                    padding-top: 7px;
                }
                .qipao-scoredes {
                    white-space: nowrap;
                    color: #fff;
                    font-size: 9px;
                    line-height: 12px;
                    text-align: center;
                    padding: 8px;
                }
            }
            .qipao-bg-gray {
                color: #fff;
                background-image: url('@{asserts}/qipao-gray@2x.png');
            }
            .qipao-bg-zw {
                color: #d27c16;
                background-image: url('@{asserts}/qipao-zhanwei@2x.png');
            }
            .qipao-title {
                margin-top: 5px;
                margin-left: -4px;
                color: #fff;
                font-size: 10px;
                text-align: center;
                line-height: 12px;
                width: 92%;
                // height: 36px;
                text-align: center;
                .hand-qp {
                    display: inline-block;
                    width: 12px;
                    height: 12px;
                    background-size: 100% 100%;
                    background-image: url('@{asserts}/qp_hand@2x.png');
                    margin-top: -1px;
                    margin-right: -2px;
                }
            }
            .marketingtips {
                height: 24px;
                line-height: 24px;
                margin: 0 auto;
                text-align: center;
                border-radius: 4px;
                // background-image: linear-gradient(to bottom, #000, #343434);
                background: linear-gradient(180deg, #00324c 0%, #0d1e29 100%);
                position: relative; /*子绝父相*/
                color: #fff;
                font-size: 12px;
                margin-top: -105px;
                white-space: nowrap;
                padding: 0 4px;
                opacity: 0.8;
                .yx-tip-butn {
                    color: #fcab32;
                    margin-left: 4px;
                }
                .yx-arraw {
                    width: 10px;
                    height: 10px;
                    background-image: url('@{asserts}/yx-qp-arraw@2x.png');
                    background-size: 100% 100%;
                    display: inline-block;
                    position: relative;
                    top: 1px;
                    margin-top: 4px;
                }
            }
            .left-tip {
                margin-left: 6px;
            }
            .right-tip {
                margin-left: -2px;
            }
            .marketingtips::before {
                content: '';
                width: 0;
                height: 0;
                /*IE6下，height:0;不顶用，可使用font-size:0; + overflow:hidden;修复此问题*/
                font-size: 0;
                overflow: hidden;
                display: block;
                border-width: 4px;
                border-color: #133c53 transparent transparent transparent;
                /*为了兼容IE6，所有设置为透明（transparent）的边，需要设置为dashed；有颜色的边设置为solid*/
                border-style: solid dashed dashed dashed;
                position: absolute; /*绝对定位不占位置*/
                top: 24px; /* 向下移动 矩形的高度 + 矩形的上下内边距 + 下边框粗细*/
            }
            .left-tip::before {
                left: 26px; /*相对于矩形宽度的位置*/
            }
            .right-tip::before {
                right: 32px;
            }
        }
    }
    .score-area {
        margin: 45px 16px 0;
        padding-left: 20px;
        position: absolute;
        width: 343px;
        height: 170px;
        background-image: url('@{assertsV4}garde-card-ic@2x.png');
        background-size: 100% 100%;
        .score-top {
            display: flex;
            flex-direction: row;
            align-items: center;
            margin-top: 34px;
            margin-bottom: 10px;
            .grade-ic {
                width: 27px;
                height: 21px;
                background-size: 100% 100%;
                background-image: url('@{assertsV4}level-bg-ic@2x.png');
                padding-top: 1px;
                .curr-level {
                    margin-left: 17px;
                    color: #f88800;
                    font-size: 8px;
                    font-weight: bold;
                }
            }
            .score-title {
                margin-left: 4px;
                color: #fff5e4;
                font-size: 13px;
            }
            .arrow-right {
                margin-left: 3px;
                width: 6px;
                height: 9px;
                background-image: url('@{assertsV4}arrow-right@2x.png');
                background-size: 100% 100%;
            }
        }
        .score-value {
            color: #ffffff;
            font-size: 34px;
            font-weight: bolder;
            font-family: uni_sans_regular;
        }
        .score-botm {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            margin-top: 34px;
            padding-right: 14px;
            .score-badge {
                font-size: 10px;
                color: #fff5e4;
            }
            .curr-grate {
                margin-top: -4px;
                height: 42px;
                color: #fff;
                font-size: 42px;
                font-weight: bold;
                opacity: 0.1;
            }
        }
    }
}
.left-tip::before {
    left: 26px; /*相对于矩形宽度的位置*/
}
.right-tip::before {
    right: 32px;
}
</style>
<style lang="less">
@keyframes qipaofloat {
    from {
        transform: translate(0, 0);
    }
    to {
        transform: translate(0, 4px);
    }
}

@keyframes vertical-collect-in-1 {
    0% {
        transform: translateY(0px);
    }
    32% {
        transform: translateY(-80px);
    }
    100% {
        transform: translateY(-10px);
    }
}

@keyframes hor-collect-in-1 {
    0% {
        opacity: 1;
        transform: translateX(0px) scale(1, 1);
    }
    40% {
        opacity: 1;
        transform: translateX(-60px) scale(1, 1);
    }
    100% {
        opacity: 0;
        transform: translateX(-120px) scale(0, 0);
    }
}

@keyframes vertical-collect-in-2 {
    0% {
        transform: translateY(0px);
    }
    32% {
        transform: translateY(-90px);
    }
    100% {
        transform: translateY(20px);
    }
}

@keyframes hor-collect-in-2 {
    0% {
        opacity: 1;
        transform: translateX(0px) scale(1, 1);
    }
    40% {
        opacity: 1;
        transform: translateX(-100px) scale(1, 1);
    }
    100% {
        opacity: 0;
        transform: translateX(-170px) scale(0, 0);
    }
}

@keyframes vertical-collect-in-3 {
    0% {
        transform: translateY(0px);
    }
    32% {
        transform: translateY(-100px);
    }
    100% {
        transform: translateY(-60px);
    }
}

@keyframes hor-collect-in-3 {
    0% {
        opacity: 1;
        transform: translateX(0px) scale(1, 1);
    }
    40% {
        opacity: 1;
        transform: translateX(-70px) scale(1, 1);
    }
    100% {
        opacity: 0;
        transform: translateX(-140px) scale(0, 0);
    }
}

@keyframes vertical-collect-in-4 {
    0% {
        transform: translateY(0px);
    }
    32% {
        transform: translateY(-140px);
    }
    100% {
        transform: translateY(-50px);
    }
}

@keyframes hor-collect-in-4 {
    0% {
        opacity: 1;
        transform: translateX(0px) scale(1, 1);
    }
    40% {
        opacity: 1;
        transform: translateX(-120px) scale(1, 1);
    }
    100% {
        opacity: 0;
        transform: translateX(-230px) scale(0, 0);
    }
}

@keyframes vertical-collect-in-5 {
    0% {
        transform: translateY(0px);
    }
    32% {
        transform: translateY(-80px);
    }
    100% {
        transform: translateY(20px);
    }
}

@keyframes hor-collect-in-5 {
    0% {
        opacity: 1;
        transform: translateX(0px) scale(1, 1);
    }
    40% {
        opacity: 1;
        transform: translateX(-140px) scale(1, 1);
    }
    100% {
        opacity: 0;
        transform: translateX(-270px) scale(0, 0);
    }
}
</style>
